import { endpoints } from '../constants/endpoints';
import axios from '../lib/axios';
import type { WhatsappTemplate } from '../types/whatsapp';

export async function downloadRecipientSheet(template: WhatsappTemplate) {
  const sheet: Blob = await axios.get(
    endpoints.whatsapp.recipientSheet(template.meta_id),
    { responseType: 'blob' },
  );

  const url = URL.createObjectURL(sheet);
  const link = document.createElement('a');
  link.href = url;
  link.download = `recipients_${template.name}.csv`;
  link.click();
  URL.revokeObjectURL(url);
}
